import { pickDefaultModelResult } from '@upright/common/model/data-point-pickers';
import { useCompanyScores } from '@upright/ui/views/model-entity-views/company-view/use-company-scores';

export function useGetCompanyVariantId(companyId: string) {
  const modelEntityScoreData = useCompanyScores(companyId);

  const defaultResult = modelEntityScoreData.data?.modelResults.length
    ? pickDefaultModelResult(modelEntityScoreData.data.modelResults)
    : undefined;

  return defaultResult?.variantId;
}
